// 站点明细
export const siteConfig = {
    configuration: true,
    table: {
        leftWidth: 100,
        height: 250,
        selection: true,
        columns: [
            {
                label: '站点类型',
                prop: 'siteTypeName',
                sort: true,
                width: 140
            },
            {
                label: '站点地址',
                prop: 'siteAddress',
                sort: true,
                width: 200
            },
            {
                label: '运抵状态',
                prop: 'statusName',
                sort: true,
                width: 140
            },
            {
                label: '单量',
                prop: 'count',
                sort: true,
                width: 140
            },
            {
                label: '总重量(kg)',
                prop: 'totalWeight',
                sort: true,
                width: 140
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 140
            },
            {
                label: '抵达时间',
                prop: 'arrivalConfirmTime',
                sort: true,
                width: 140
            },
            {
                label: '抵达方式',
                prop: 'arrivalConfirmTypeName',
                sort: true,
                width: 140
            },
            {
                label: '抵达人工操作原因',
                prop: 'arrivalOperateReason',
                sort: true,
                width: 140
            }
        ],
        action: {
            fixedWidth: 80,
            list: [
                {
                    type: 'text',
                    label: '运抵确认',
                    size: 'mini',
                    event: 'shipTo',
                    displayRule: row => {
                        if (+row.status === 0) {
                            return true;
                        }
                    }
                },
                {
                    type: 'text',
                    label: '取消运抵',
                    size: 'mini',
                    event: 'cancelShipTo',
                    displayRule: row => {
                        if (+row.status === 1) {
                            // 抵达方式:上传回单抵达禁用
                            if (row.arrivalConfirmType === '04') {
                                return false;
                            }
                            return true;
                        }
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }
};
// 运单明细
export const waybillConfig = {
    configuration: true,
    table: {
        leftWidth: 100,
        height: 250,
        selection: true,
        columns: [
            {
                label: '运抵状态',
                prop: 'statusName',
                sort: true,
                width: 140
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: 140
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                sort: true,
                width: 180
            },
            {
                label: '客户',
                prop: 'customerName',
                sort: true,
                width: 140
            },
            {
                label: '转单货站',
                prop: 'stationNames',
                sort: true,
                width: 140
            },
            {
                label: '总重量(kg)',
                prop: 'totalWeight',
                sort: true,
                width: 100
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 100
            },
            {
                label: '抵达时间',
                prop: 'arrivalConfirmTime',
                sort: true,
                width: 140
            },
            {
                label: '抵达方式',
                prop: 'arrivalConfirmTypeName',
                sort: true,
                width: 120
            },
            {
                label: '收货人',
                prop: 'receiverName',
                sort: true,
                width: 100
            },
            {
                label: '收货电话',
                prop: 'receiverMobile',
                sort: true,
                width: 140
            },
            {
                label: '配送方式',
                prop: 'deliveryTypeName',
                sort: true,
                width: 100
            },
            {
                label: '抵达人工操作原因',
                prop: 'arrivalOperateReason',
                sort: true,
                width: 140
            }
        ],
        action: {
            fixedWidth: 80,
            list: [
                {
                    type: 'text',
                    label: '运抵确认',
                    size: 'mini',
                    event: 'shipToByTransport',
                    displayRule: row => {
                        if (+row.status === 0) {
                            return true;
                        }
                    }
                },
                {
                    type: 'text',
                    label: '取消运抵',
                    size: 'mini',
                    event: 'cancelShipToByTransport',
                    displayRule: row => {
                        if (+row.status === 1) {
                            // 抵达方式:上传回单抵达禁用
                            if (row.arrivalConfirmType === '04') {
                                return false;
                            }
                            return true;
                        }
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }
};
export const tabSList = [
    {
        name: 'siteDetails',
        label: '站点明细'
    },
    {
        name: 'waybillDetails',
        label: '运单明细'
    }
];
